<a class="form-link" tabindex="0">
  <ng-content></ng-content>
</a>